<template>
  <footer class="footer">
    <notice/>
    <!-- 웨이브온 푸터 -->
    <div v-if="isPooqzone && pooqzoneInfo.footerimage"  class="footer-company">
      <div class="wrap">
        <a :href="pooqzoneInfo.footerlink | url" target="_blank"><img
          :src="pooqzoneInfo.footerimage | url" alt="" /></a>
      </div>
    </div>
    <footer-info :isService="isService"/>
  </footer>
</template>

<script>
import FooterInfo from './footer/FooterInfo'
import Notice from './footer/Notice'
import { url } from '@/common/filters/url.filter'
import cookie from '@/common/utils/cookie'

export default {
  components: {
    FooterInfo,
    Notice
  },
  filters: {
    url
  },
  props: {
    isService: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      pooqzoneInfo: cookie.getPooqZoneInfo()
    }
  }
}
</script>

<style lang="css">
/* footer */
.footer{
  background-color: #1b1b1b;
  width: 100%;
  border-top: solid 1px #2f2f2f;
  min-width: 1240px;
  overflow: hidden;
}

.footer-notice{
  width: 100%;
  border-bottom: solid 1px #2f2f2f;
}

.footer-notice .swiper-container{
  height: 50px;
}

.footer-notice ul{
  width: 1240px;
  margin: 0 auto;
  position: relative;
  height: 50px;
  line-height: 50px;
  z-index: 1000;
}

.footer-notice > ul > li:first-child{
  margin-right: 22.5px;
  float: left;
  vertical-align: middle;
}

.footer-notice .swiper-container li{
  margin-right: 22.5px;
  float: left;
  vertical-align: middle;
}

.footer-notice ul li a.text01{
  display: block;
  font-size: 18px;
  color: #a5a5a5;
}

.footer-notice ul li a.text02{
  font-size: 16px;
  color: #a5a5a5;
}

.footer-notice .swiper-button-next a,
.footer-notice .swiper-button-prev a{
  display: block;
}

.footer-notice .swiper-button-next img,
.footer-notice .swiper-button-prev img{
  vertical-align: top;
}

.footer-notice .footer-arrow-right{
  position: absolute;
  top: 0;
  right: 0;
  border-right: solid 1px #2f2f2f;
  border-left: solid 1px #2f2f2f;
  height: 50px;
}

.footer-notice .footer-arrow-left{
  position: absolute;
  top: 0;
  right: 54px;
  border-left: solid 1px #2f2f2f;
  height: 50px;
}

.footer-notice .footer-arrow-right,
.footer-notice .footer-arrow-left{
  display: block;
}

.footer-notice .footer-arrow-right:hover img, .footer-notice .footer-arrow-left:hover img{
  opacity: .3;
}

/* footer > 하단 메뉴 */
.footer-menu{
  width: 1240px;
  margin: 0 auto;
  padding: 0 0 100px;
  position: relative;
  overflow: hidden;
  color: #717171;
}

.footer-info-area a {
  color: #717171;
}

.footer-info-area a:hover,
.footer-info-area a.on{
  color: #1351f9;
}

.footer-info-link-all{
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
}

.footer-info-link-all ul:after{
  display: block;
  clear: both;
  content: '';
}

.footer-info-link-all li{
  float: left;
  margin-right: 24px;
}

.footer-info-link-all a{
  display: block;
  padding: 10px 0;
}

.footer-info-link-all .footer-privacy a{
  font-weight: 700;
  color: #a5a5a5;
}

.footer-info-copyright{
  font-size: 12px;
  line-height: 20px;
}

.footer-info-copyright .info-link{
  text-decoration: underline;
}

.footer-info-copyright span,
.footer-info-copyright address{
  display: inline-block;
  border-right: solid 1px #717171;
  padding-right: 6px;
  margin-right: 6px;
  line-height: 11px;
}

.footer-info-copyright address{
  margin-left: 0;
  font-style: normal;
}

.footer-info-copyright .last{
  border: 0;
}

.footer-info-copyright .copyright{
  display: block;
  margin-top: 10px;
  border: 0;
}

/* footer > 웨이브온 */
.footer-menu .footer-wavveon{
  position: absolute;
  right: 0;
  top: 20px;
  height: 40px;
  font-size: 0;
}

.wavveon-footer-logo{
  display: inline-block;
  vertical-align: middle;
  width: 94px;
  height: 38px;
  margin-right: 1px;
  font-size: 0;
  line-height: 38px;
  text-align: center;
  background-color: #252525;
}

.footer-menu .footer-wavveon select{
  display: inline-block;
  vertical-align: middle;
  width: 225px;
  height: 38px;
  padding-left: 13px;
  margin-right: 10px;
  line-height: 32px;
  color: #a5a5a5;
  border: 1px solid #252525;
  background: url(../../assets/images/common/footer-input-arrow.png) #252525 96% 50% no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.footer-sns{
  display: inline-block;
  vertical-align: middle;
}

.footer-sns a + a{
  margin-left: 5px;
}

.footer-sns a{
  display: inline-block;
  width: 34px;
  padding: 1px 1px;
}

.footer-sns img{
  display: block;
  max-width: 100%;
}

.footer-company{
  background: #f8f8f8;
  text-align: center;
}
</style>
